/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { DownloadLogRequest, PagedResponseDownloadLogDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class DownloadLogController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags download-log-controller
   * @name GetDownloadLogs
   * @request POST:/api/v1/download-logs
   */
  getDownloadLogs = (data: DownloadLogRequest, params: RequestParams = {}) =>
    this.http.request<PagedResponseDownloadLogDto, any>({
      path: `/v1/download-logs`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getDownloadLogsPath = '/v1/download-logs'
  static getDownloadLogsMethod = 'POST'
}
